import { PropsWithChildren } from "react";
import { ComboBoxContext, ComboBoxContextValue } from "./ComboBoxContext";

export function ComboBoxProvider({
  children,
  ...props
}: PropsWithChildren<ComboBoxContextValue>) {
  return (
    <ComboBoxContext.Provider value={props}>
      {children}
    </ComboBoxContext.Provider>
  );
}
